import React,{useEffect, useState} from 'react'
import { url } from '../../../api/api'

const ImageModal = ({docsImg}) => {
    const [img, setImg] = useState('')
    
    useEffect(() => {
       let newImg = docsImg.replace(url, '')
    //    console.log(newImg)
        setImg(newImg)

    }, [docsImg])

   

  return (
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="docsModalDemo"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            {
                docsImg === ""? 'No Image to show' : <img src={`${url}/${img}`} className='w-48 object-fill m-auto' />
            }
        {/* <h1>Hello world</h1> */}
        
        </div>
        
      </div>
    </div>
  </div>
  )
}

export default ImageModal